import StepHeader from '../StepHeader';
import { CONNECTING_PREFIX } from '../../utils/translationPagePrefix';
import { useTranslation } from 'react-i18next';
import { Bank } from '../../services/interfaces/bank.interface';

interface ConnectingProps {
	bank: Bank;
}

const Connecting = ({ bank }: ConnectingProps) => {
	const { t } = useTranslation();

	const titleText = t(`${CONNECTING_PREFIX}.title`);
	const subtitleText = t(`${CONNECTING_PREFIX}.subtitle`);
	return (
		<StepHeader
			title={`${titleText} ${bank.name}`}
			subtitle={subtitleText}
			bankName={bank.name}
			withSpinner={true}
		/>
	);
};

export default Connecting;
